import { createContext, ReactNode, useContext } from 'react'

export type HeaderMenuItems = {
  id: 'categories' | 'subcategories'
  items: {
    id: string
    name: string
    slug: string
    displayOrder: number
  }[]
}[]

interface HeaderMenuItemsContextType {
  headerMenuItems: HeaderMenuItems
}

const HeaderMenuItemsContext = createContext<
  HeaderMenuItemsContextType | undefined
>(undefined)

interface HeaderMenuItemsProviderProps {
  headerMenuItems: HeaderMenuItems
  children: ReactNode
}

export function HeaderMenuItemsProvider({
  headerMenuItems,
  children,
}: HeaderMenuItemsProviderProps) {
  return (
    <HeaderMenuItemsContext.Provider value={{ headerMenuItems }}>
      {children}
    </HeaderMenuItemsContext.Provider>
  )
}

export function useHeaderMenuItems() {
  const context = useContext(HeaderMenuItemsContext)

  if (!context) {
    throw new Error(
      'useHeaderMenuItems must be used as a child of a HeaderMenuItemsProvider'
    )
  }

  return context
}
